import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  PaymentMethodExceptionLimitCreateRequestPayload,
  PaymentMethodExceptionLimit,
  PaymentMethodCreateExceptionLimit,
} from '@/models/ps-management/exception-limit.model';

export default
class CreatePaymentMethodExceptionLimitRequest extends ApiResourceMethod<PaymentMethodCreateExceptionLimit> {
  public perform(payload: PaymentMethodExceptionLimitCreateRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `paymentMethodSettings/${payload.paymentMethodSettingsId}/extendedLimit`,
        data: payload.paymentMethodExceptionData,
      },
      (response: BaseResponse<PaymentMethodExceptionLimit>): PaymentMethodExceptionLimit => {
        return response.data;
      },
    );
  }
}
